
import React from 'react';

const AboutSection: React.FC = () => {
  const achievements = [
    { number: '17', label: 'Anos de experiência' },
    { number: '30+', label: 'Anos como servidora' },
    { number: '2 pós-graduações', label: 'Previdenciário e Consumidor' },
    { number: 'Atendimento', label: 'Humanizado' }
  ];

  const qualifications = [
    'Graduação em Direito',
    'Graduação em História', 
    'Pós-graduação em Direito Previdenciário',
    'Pós-graduação em Direito do Consumidor',
    'OAB/PR 106594'
  ];

  const differentials = [
    {
      icon: 'ri-heart-line',
      title: 'Advogada PCD',
      description: 'Empatia real com o público de pessoas com deficiência, compreendendo suas necessidades específicas.'
    },
    {
      icon: 'ri-government-line',
      title: 'Ex-Servidora Pública',
      description: 'Mais de 30 anos de experiência nos setores municipal, estadual e federal.'
    },
    {
      icon: 'ri-award-line',
      title: 'Análise individual de cada caso',
      description: 'Atuação técnica com comunicação clara em todas as etapas.'
    },
    {
      icon: 'ri-time-line',
      title: 'Atuação célere e informativa',
      description: 'Priorizamos orientação clara, prazos realistas e atualização do andamento.'
    }
  ];

  return (
    <section id="sobre" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#214134] mb-6">
            Sobre a Dra. Albiana Guerreiro
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça a trajetória de uma profissional dedicada ao direito previdenciário 
            e comprometida com o atendimento humanizado.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          {/* Imagem e Informações */}
          <div className="space-y-8">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/1f73a5d8b2b701c55045833ecbd14f31.png"
                alt="Dra. Albiana Guerreiro em seu escritório"
                className="w-full lg:w-[720px] xl:w-[960px] min-h-[520px] object-cover rounded-[18px] shadow-lg"
                style={{ objectPosition: '50% 20%', aspectRatio: '4/3' }}
              />
              <div className="absolute -bottom-6 -right-6 bg-[#cc9b3f] text-[#214134] p-6 rounded-xl shadow-lg">
                <div className="text-center">
                  <div className="text-3xl font-bold">OAB/PR</div>
                  <div className="text-lg font-semibold">106594</div>
                </div>
              </div>
            </div>

            {/* Números */}
            <div className="grid grid-cols-2 gap-4">
              {achievements.map((achievement, index) => (
                <div key={index} className="text-center p-4 bg-gray-50 rounded-xl">
                  <div className="text-3xl font-bold text-[#cc9b3f] mb-2">
                    {achievement.number}
                  </div>
                  <div className="text-sm font-semibold text-[#214134]">
                    {achievement.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Conteúdo */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-[#214134] mb-4">
                Uma Trajetória de Dedicação e Experiência
              </h3>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong className="text-[#214134]">Dra. Albiana Guerreiro</strong> é advogada desde 2008, 
                  iniciando sua carreira no Rio de Janeiro em uma Associação de Deficientes Visuais, 
                  onde desenvolveu sua paixão pelo atendimento humanizado.
                </p>
                <p>
                  Em 2020, mudou-se para Maringá/PR, onde se aposentou como servidora pública após 
                  uma carreira de mais de 30 anos nos setores municipal e estadual.
                </p>
                <p>
                  Como pessoa com deficiência, a Dra. Albiana compreende profundamente as necessidades 
                  e desafios enfrentados por seus clientes, oferecendo um atendimento verdadeiramente 
                  empático e especializado.
                </p>
              </div>
            </div>

            {/* Formação */}
            <div>
              <h4 className="text-xl font-bold text-[#214134] mb-4">Formação Acadêmica</h4>
              <ul className="space-y-2">
                {qualifications.map((qualification, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <div className="w-6 h-6 bg-[#cc9b3f] rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-sm text-white"></i>
                    </div>
                    <span className="text-gray-700">{qualification}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Diferenciais */}
        <div>
          <h3 className="text-3xl font-bold text-[#214134] text-center mb-12">
            Nossos Diferenciais
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {differentials.map((differential, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-[#214134] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${differential.icon} text-2xl text-[#cc9b3f]`}></i>
                </div>
                <h4 className="text-lg font-bold text-[#214134] mb-3">
                  {differential.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {differential.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
